import About from "./routes/About";
import Contact from "./routes/Contact";
import Home from "./routes/Home";
import Services from "./routes/Services";
import { Route, Routes } from "react-router-dom";


export default function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Services" element={<Services/>} />
        <Route path="/Contact" element={<Contact/>} />
      </Routes>
    </div>
  );
}
